module.exports = __webpack_public_path__ + "af92c6ade26ddc77e59085792c5ff912.png";